/* global localStorage */
import ApiService from '@/common/api.service'

import { FECTH_PROJECTS, FECTH_PLUGINS_PROJECT } from '@/store/actions.type'
import { SET_ERROR, SET_PROJECTS, SET_PLUGINS_PROJECT } from '@/store/mutations.type'

const state = {
    errors: null,
    projects: null,
    pluginsProject: null
}

const getters = {
    getProjects(state) {
        return state.projects
    },
    getPluginsProject(state) {
        return state.pluginsProject
    }
}

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error
    },
    [SET_PROJECTS](state, projects) {
        state.projects = projects
        state.errors = {}
    },
    [SET_PLUGINS_PROJECT](state, plugins) {
        state.pluginsProject = plugins
        state.errors = {}
    }
}

const actions = {
    [FECTH_PROJECTS](context, data) {
        if (this.projects) {
            return this.getProjects()
        }
        return new Promise((resolve) => {
            ApiService
            .post('projects', data)
            .then((data) => {
                context.commit(SET_PROJECTS, data.data.response)
                resolve(data.data.response)
            })
            .catch((data) => {
                context.commit(SET_ERROR, data)
            })
        })
    },
    async [FECTH_PLUGINS_PROJECT](context) {
        await ApiService.post("admin/plugins-project", {
            token: localStorage.getItem("token"),
            project: localStorage.getItem("table")
        }).then(response => {
            context.commit(SET_PLUGINS_PROJECT, response.data)
        })
    }

}

export default {
    state,
    mutations,
    getters,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/projects.js